import type { SalesPageComponent } from 'queries/graphql';

import Accordion from 'generic/Accordion';
import BulletList from 'generic/BulletList';
import Hero from 'generic/Hero';
import Banner from 'generic/Banner';
import Guarantee from 'generic/Guarantee';
import HeaderLogo from 'generic/HeaderLogo';
import Comparison from 'generic/Comparison';
import DetailList from 'generic/DetailList';
import FeaturedIn from 'generic/FeaturedIn';
import HeadingImageText from 'generic/HeadingImageText';
import ValueProposition from 'generic/ValueProposition';
import Testimonial from 'generic/Testimonial';

import Container from './Container';
import MultiVariantBundle from './MultiVariantBundle';
import FinalCta from './FinalCta';
import Callout from './Callout';
import AutoplayVideo from './AutoplayVideo';
import LogoBanner from './LogoBanner';
import NavBar from './NavBar';
import PeopleLooking from './PeopleLooking';
import ReviewStars from './ReviewStars';
import ColumnImage from './ColumnImage';
import ImageCarousel from './ImageCarousel';
import StickyBanner from './StickyBanner';
import FunnelCart from './FunnelCart';
import MultiBundle from './MultiBundle';
import VideoSection from './VideoSection';

export function HeaderComponents({ components }: { components: SalesPageComponent[] }) {
  return components.map((component, index) => {
    const { banner, navBar, headerLogo, stickyBanner } = component;

    if (navBar) {
      return <NavBar key={index} {...navBar} />;
    } else if (stickyBanner) {
      return <StickyBanner key={index} {...stickyBanner} />;
    } else if (banner) {
      return <Banner key={index} {...banner} />;
    } else if (headerLogo) {
      return <HeaderLogo key={index} {...headerLogo} />;
    }

    return null;
  });
}

export function Components({ components }: { components: SalesPageComponent[] }) {
  return components.map((component, index) => {
    const {
      callout,
      hero,
      bulletList,
      accordion,
      finalCta,
      autoplayVideo,
      comparison,
      detailList,
      featuredIn,
      guarantee,
      headingImageText,
      logoBanner,
      peopleLooking,
      reviewStar,
      valueProposition,
      container,
      columnImage,
      imageCarousel,
      testimonial,
      funnelCart,
      multiBundle,
      multiVariantBundle,
      videoSection,
    } = component;

    if (container) {
      return <Container key={index} {...container} />;
    } else if (hero) {
      return <Hero key={index} {...hero} />;
    } else if (accordion) {
      return <Accordion key={index} {...accordion} />;
    } else if (bulletList) {
      return <BulletList key={index} {...bulletList} />;
    } else if (finalCta) {
      return <FinalCta key={index} {...finalCta} />;
    } else if (callout) {
      return <Callout key={index} {...callout} />;
    } else if (autoplayVideo) {
      return <AutoplayVideo key={index} {...autoplayVideo} />;
    } else if (comparison) {
      return <Comparison key={index} {...comparison} />;
    } else if (detailList) {
      return <DetailList key={index} {...detailList} />;
    } else if (featuredIn) {
      return <FeaturedIn key={index} {...featuredIn} />;
    } else if (guarantee) {
      return <Guarantee key={index} {...guarantee} />;
    } else if (headingImageText) {
      return <HeadingImageText key={index} {...headingImageText} />;
    } else if (logoBanner) {
      return <LogoBanner key={index} {...logoBanner} />;
    } else if (peopleLooking) {
      return <PeopleLooking key={index} {...peopleLooking} />;
    } else if (reviewStar) {
      return <ReviewStars key={index} {...reviewStar} />;
    } else if (valueProposition) {
      return <ValueProposition key={index} {...valueProposition} />;
    } else if (columnImage) {
      return <ColumnImage key={index} {...columnImage} />;
    } else if (imageCarousel) {
      return <ImageCarousel key={index} {...imageCarousel} />;
    } else if (videoSection) {
      return <VideoSection key={index} {...videoSection} />;
    } else if (testimonial) {
      return <Testimonial key={index} {...testimonial} />;
    } else if (funnelCart) {
      return <FunnelCart key={index} {...funnelCart} />;
    } else if (multiBundle) {
      return <MultiBundle key={index} {...multiBundle} />;
    } else if (multiVariantBundle) {
      return <MultiVariantBundle key={index} {...multiVariantBundle} />;
    }

    return null;
  });
}
